import React, {  useEffect, useState,useRef,useContext  } from "react";



export default function Shift4_3ds(props) {
    window.location.replace(props.action);
}